module.exports = __webpack_public_path__ + "img/deco1.cbd59289.svg";